import { render, staticRenderFns } from "./alertaTodasAbas.vue?vue&type=template&id=386e8d6c&"
import script from "./alertaTodasAbas.vue?vue&type=script&lang=js&"
export * from "./alertaTodasAbas.vue?vue&type=script&lang=js&"
import style0 from "./alertaTodasAbas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports